// @core/api/endpoints/project/create_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ComponentResponse,
  CreateComponentRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create component
 * Creates a new component for categorizing project items by functional area (e.g., Frontend, Backend, API). Items can belong to multiple components.
 */
export async function CreateComponent(
  project_id: string,
  data: CreateComponentRequest,
  options?: RequestOptions
): Promise<ComponentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ComponentResponse>(requestPath, data, requestOptions);
}
